'use client';
import TestimonialVids from '@/components/testimonialVidSlider/testimonial-vids.component';
import { Box } from '@mui/material';
import { useTranslation } from '@/hook';
import styles from './styles.module.scss';
import { useAnalytics } from '@/integrations';
import { NewTestimonialSection } from '../acquisition';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_TESTIMONIALS } from '@/constants';

const VidTestimonialsSection = ({ SourceScreen }: { SourceScreen: string }) => {
    const experimentFlag = useFeatureIsOn(FEATURE_FLAG_TESTIMONIALS);
    const { t } = useTranslation();
    const { trackEvent } = useAnalytics();
    return (
        experimentFlag && (
            <Box className={styles.testimonials}>
                <h2>{t('sellPage.whatTheySaid')}</h2>
                <TestimonialVids
                    gtmEvent={() =>
                        trackEvent('Action: Watch_Testimonials', {
                            SourceScreen,
                        })
                    }
                    sourceScreen={SourceScreen}
                    backgroundColor={'#f3fffa'}
                />
                <div className={styles.separator_line}></div>
                <NewTestimonialSection sourceScreen={SourceScreen} />
            </Box>
        )
    );
};

export default VidTestimonialsSection;
